import type { TOC } from '@ember/component/template-only';

import type { TimeUnit } from 'webapp/enums/enums';

import ForecastsSettingsAdditionalSettingsComponent from 'webapp/components/forecasts/settings/additional-settings';
import ForecastsSettingsForecastMethodologyComponent from 'webapp/components/forecasts/settings/forecast-methodology';

import type { Forecast } from 'webapp/models-custom';
import type { ForecastMethodology } from 'webapp/models-custom/forecast';

interface Args {
	forecast: Forecast;
	isDisabled: boolean;
	allowedSeasonality: TimeUnit[];
	onChangeMethodology: (methodology: ForecastMethodology) => void;
	onChangeParameters: (seasonality: TimeUnit[], holidaysCountry: string) => void;
}

const MetricDetailsSettingsForecastMethodologyComponent: TOC<{ Args: Args }> = <template>
	<div class="metric-explorer-settings__section metric-explorer-settings__methodology">
		<ForecastsSettingsForecastMethodologyComponent
			@forecast={{@forecast}}
			@isDisabled={{@isDisabled}}
			@onChange={{@onChangeMethodology}}
		/>
	</div>

	<hr class="metric-explorer-settings__section-divider" />

	<div class="metric-explorer-settings__section metric-explorer-settings__methodology">
		<ForecastsSettingsAdditionalSettingsComponent
			@isDisabled={{@isDisabled}}
			@seasonality={{@forecast.seasonality}}
			@allowedSeasonality={{@allowedSeasonality}}
			@holidaysCountry={{@forecast.holidaysCountry}}
			@onChange={{@onChangeParameters}}
		/>
	</div>
</template>;

export default MetricDetailsSettingsForecastMethodologyComponent;
